import styled from 'styled-components';
import camelCase from 'lodash/camelCase';
import { useTranslation } from 'react-i18next';
import { Box, FormProvider, Tabs, mainTheme } from 'dash-ui';
import { useLocation, useNavigate } from 'react-router-dom';

import { RoutesPath } from 'flow-components/routes/routes';
import { getCurrentTabFromSearchParam } from 'common/helpers/route.helper';

import {
  OrganizationTabsKeys,
  DEFAULT_ORGANIZATION_TAB_KEY,
} from './OrganizationDetailsTabs.constants';
import { OrganizationUsers, InternalSaleTeamForm } from './components';
import { SaveSaleFormFieldsList } from './components/InternalSaleTeamForm/InternalSaleTemForm.constants';

const TabsBox = styled(Box)`
  border-top: 1px solid ${mainTheme.colors.n30};
  border-bottom: 1px solid ${mainTheme.colors.n30};
`;

function OrganizationDetailsTabs({
  organizationId,
}: {
  organizationId: string;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t: tCommonLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });
  const currentTab = getCurrentTabFromSearchParam(
    location.search
  ) as OrganizationTabsKeys;
  const activeTab = currentTab || DEFAULT_ORGANIZATION_TAB_KEY;

  return (
    <FormProvider fieldsList={SaveSaleFormFieldsList}>
      <TabsBox w="100%">
        <Tabs
          variation="secondary"
          tabs={Object.values(OrganizationTabsKeys).map((key) => ({
            key,
            label: tCommonLabels(camelCase(key)),
          }))}
          activeTab={activeTab}
          onClick={(key) => navigate(`${RoutesPath.Organization}?tab=${key}`)}
        />
      </TabsBox>
      <Box w="100%">
        {activeTab === OrganizationTabsKeys.USERS && (
          <OrganizationUsers filter={{ organizationId }} />
        )}
        {activeTab === OrganizationTabsKeys.INTERNAL_SALE_TEAM && (
          <InternalSaleTeamForm />
        )}
      </Box>
    </FormProvider>
  );
}

export default OrganizationDetailsTabs;
